// @ts-nocheck
import { Box, Text, Flex, HStack, Grid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import { roundUp } from "utils/helpers"
import { getAccount } from "utils/sessionHelper";
import { format, formatDistance } from "date-fns";
import { useSession } from "next-auth/client";
import { color, textStyle } from "theme/names";

export function Account({ tweetStats = [], accountStats = [], isDataCollectionWarning=false }) {
  
  const [session, loading] = useSession();

  const followersChange =
    accountStats[accountStats?.length - 1]?.followers_count -
      accountStats[0]?.followers_count || 0;
  const followerChangePercent =
    (followersChange * 100) / accountStats[0]?.followers_count;
  const sign = followersChange > 0 ? "+" : "";

  let impressions = 0,
    profileVisits = 0,
    engagement = 0;
  if (tweetStats?.length > 0) {
    tweetStats.forEach((tweet) => {
      impressions += tweet.non_public_metrics.impression_count;
      profileVisits += tweet.non_public_metrics.user_profile_clicks;
      engagement += tweet.public_metrics.total_engagement;
    });
  }

  return (
    <Box>
      <Grid
        // alignItems={{ base: "center", md: "space-between" }}
        // templateColumns={{ xl: "repeat(4, 1fr)", lg: "repeat(2, 1fr)", sm: "repeat(1, 1fr)" }}
        // columnGap={{ lg: 10, md: 0 }}
        // rowGap={0}
        // fontWeight="bold"
        // paddingY="16"
        gridTemplateColumns={[
          "1fr 1fr", 
          "1fr 1fr",
          "1fr 1fr",
          "1fr 1fr 1fr 1fr",
          ]} 
          gap={[2, 4, 6]}
          justifyItems="center"
          // mt={10}
          mt={{ base: "120px", md: "12" }}
          mb={20}
      >
        {/* <CustomBox>
          <Text color="red" fontSize="lg">
            7
          </Text>
          <Text>DAYS STREAK</Text>
        </CustomBox> */}
        <CustomBox title="FOLLOWER GROWTH" value={sign + roundUp(followersChange)} diff={sign + followerChangePercent.toFixed(1) + "%"} />
        <CustomBox title="PROFILE VISITS" value={roundUp(profileVisits)} />
        <CustomBox title="TOTAL ENGAGEMENT" value={roundUp(engagement)} />
        <CustomBox title="IMPRESSIONS" value={roundUp(impressions)} />
      </Grid>
      {
        isDataCollectionWarning && (
          <Text mb={10} fontSize="sm" color="gray.500"><i>⚠️ Stats might be wrong since data collection started on {format(new Date(getAccount(session)?.dateAdded?._seconds*1000), 'yyyy/MM/dd') }</i></Text>
        )
      }
    </Box>
  );
}

function CustomBox({ title, value, diff = undefined, children, ...rest }) {
  return (
    <Stat 
      layerStyle={"bgBorderRoundedHoverShadow"}
      w="full"
      overflow="hidden"
      p={4}
      // py={6}
    >
        <StatLabel 
          fontWeight="600"
          textTransform="uppercase"
          textStyle={textStyle["body.medium.light"]}
          mb={0}
          letterSpacing="1.1px"
        >
          {title}
        </StatLabel>
        <Box
        textStyle={textStyle['h1.bold.standard']}
        color={color['text.lightMode.light']}
          mt={4}
         >
        {value}
        </Box>
        {
        diff && !diff.includes("NaN") && (
          // <Text fontSize="xs" color="gray" mt="1" mb="4">
          //   {diff}
          // </Text>
          <Box
            // textStyle="h2.bold.standard"
            mt={3}
            // fontSize={15}
            fontWeight="600"
            // textTransform="uppercase"
            // color={(findNumSign(boxPercentageValue)=="+")? color['secondary.lightMode.default'] :color['text.lightMode.inactive']}
            color={color['secondary.lightMode.default']}
            // mb={3}
          >
            {/* {findNumSign(boxPercentageValue)}{boxPercentageValue}% */}
            {diff}
              <Box
                as="span"
                // fontWeight="200"
                ml={1}
                mt={2}
                fontSize={12}
                // color="#909090"
                // textStyle={textStyle['body.medium.inactive']}
                textStyle="body.medium.inactive"
              >
                vs. previous period
              </Box>
            </Box>
        )
      } 
    </Stat>
  )
  
  return (
    <Box
      // boxShadow="rgb(0 0 0 / 8%) 0px 5px 10px, rgb(0 0 0 / 20%) 0px 2px 20px"
      paddingX="5"
      width="40"
      height="28"
      borderRadius="md"
      paddingTop="3"
      // marginX="5"
      // marginY="2"
      margin="auto"
      display="flex"
      flexDir="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      {...rest}
      mb={{base: diff && !diff.includes("NaN") ? 5 : 0, md: 0}}
    >
      <Text fontSize="xs" color="gray.400" w="150px">{title}</Text>
      <Text color="green.400" fontSize="4xl">{value}</Text>
      {
        diff && !diff.includes("NaN") && (
          <Text fontSize="xs" color="gray" mt="1" mb="4">
            {diff}
          </Text>
        )
      }
    </Box>
  );
}
